import { render, staticRenderFns } from "./button-download-1.vue?vue&type=template&id=3f527b26&scoped=true&"
import script from "./button-download-1.vue?vue&type=script&lang=js&"
export * from "./button-download-1.vue?vue&type=script&lang=js&"
import style0 from "./button-download-1.vue?vue&type=style&index=0&id=3f527b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f527b26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
